<template>
  <div class="compliance-outer">
    <div class="compliance-values">
      <div class="compliance-item" v-for="(item, index) in props.data" :key="index">
        <span class="percentage-value" :style="{ color: item.color }">
          {{ formatPercent(item.value || 0, 0) }}
        </span>
        <span class="label">
          {{ item.label }}
        </span>
      </div>
    </div>
    <div class="compliance-chart" :style="{ width: props.width, aspectRatio: 1 }">
      <RadialBarChartTwo
        :data="data"
        :chartOptions="{ chartSize: '5.625rem', viewBox: '14 14.5 70 70',circleRadius: 25, circleWidth: 4, gap: 6, maxPercent: 100, circles: data.length }"
      />
      <div class="logo"><slot name="logo" /></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import { formatPercent, type IChartDataItem } from '@/components/common/common'
import RadialBarChartTwo from '@/components/widgets/common/RadialBarChartTwo.vue'

const props = defineProps({
  data: {
    type: Array as PropType<IChartDataItem[]>,
    required: true,
    validator: (value: IChartDataItem[]) => {
      if (value.length > 2) {
        console.error('The "data" prop can contain at most 2 items.')
        return false
      }
      return true
    }
  },
  width: {
    type: [String, Number],
    default: '7.8125rem'
  }
})
</script>

<style scoped>
.compliance-outer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}

.compliance-values {
  display: flex;
  flex-direction: column;
  /* gap: 10px; */
}

.compliance-values .compliance-item {
  display: flex;
  flex-direction: column;
  font-family: Roboto;
  text-align: left;
  padding-left: 1.25rem;
}

.compliance-values .compliance-item .percentage-value {
  font-size: 1.3125rem;
  font-weight: 500;
}

.compliance-values .compliance-item .label {
  font-size: 0.8125rem;
  line-height: 0.8125rem;
}

.compliance-chart {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.compliance-chart .logo {
  position: absolute;
  transform: scale(0.75);
  display: flex;
  align-items: center;
  top: 2.4rem;
  left: clamp(1.8rem,9vw,2.25rem);
}
</style>
